import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../../layout/Navbar";
import Footer from "../../../layout/Footer";
import Fireclay from "../../../assets/Our Products/Mortar/FIRE-CLAY.jpg";
import Mortar70 from "../../../assets/Our Products/Mortar/70-MORTAR.jpg";
import IS8Mortar from "../../../assets/Our Products/Mortar/IS-8-MORTAR.jpg";
import ACIDProofMortar from "../../../assets/Our Products/Mortar/ACID-PROOF-MORTAR.jpg";
import ACCOSET50 from "../../../assets/Our Products/Mortar/new-lee-50.jpg";
import Thermotex from "../../../assets/Our Products/Mortar/Thernotex-1.jpeg";

const products = [
    {
        name: "Fireclay",
        image: Fireclay,
        path: "/products/fireclay"
    },
    {
        name: "70% Mortar",
        image: Mortar70,
        path: "/products/morter-70"
    },
    {
        name: "IS-8 Mortar",
        image: IS8Mortar,
        path: "/products/is-8-morter"
    },
    {
        name: "ACID Proof Mortar",
        image: ACIDProofMortar,
        path: "/products/acid-proof-morter"
    },
    {
        name: "ACCO SET-50",
        image: ACCOSET50,
        path: "/products/acco-set-50"
    },
    {
        name: "Thermotex",
        image: Thermotex,
        path: "/products/thermotex"
    },
];

const Mortar = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />
            {/* Products Section */}
            <section className="py-12 sm:py-16 lg:py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-12">
                        REFRACTORY <span className="text-orange-500">MORTAR</span>
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                        {products.map((product, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-2 overflow-hidden animate-fadeInUp"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="w-full h-56 flex items-center justify-center bg-white">
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        className="max-h-full max-w-full object-contain"
                                    />
                                </div>
                                <div className="p-6">
                                    <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 mb-4">
                                        {product.name}
                                    </h3>
                                    <Link 
                                        to={product.path}
                                        className="px-4 py-2 bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-lg hover:from-yellow-600 hover:to-orange-600 transition-all">
                                        Learn More
                                    </Link>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>
            </section>

            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fadeInUp {
                    animation: fadeInUp 0.8s ease-out forwards;
                    opacity: 0;
                }
            `}</style>
            <Footer />
        </div>
    );
};

export default Mortar;